import { FC, useState } from 'react';
import { Button } from '@mui/material';
import LocationsNearbyItem from './LocationsNearbyItem';
import NearVanModal from './NearVanModal';
import { INearVanFetch } from 'src/models/INearVan';
import './styles.scss';

interface IProps {
  vanId: number;
  homeLocation: string;
  nearVan: INearVanFetch[];
}

const LocationsNearby: FC<IProps> = ({ nearVan, vanId, homeLocation }) => {
  const [openAddNearVans, setOpenAddNearVans] = useState(false);
  const existLocations = nearVan.map(l => l.location);

  return (
    <>
      <NearVanModal
        vanId={vanId}
        homeLocation={homeLocation}
        existLocations={existLocations}
        close={openAddNearVans}
        handleClose={() => setOpenAddNearVans(false)}
      />
      <div className='nearby-locations'>
        <div className='filter__title nearby-locations__title'>
          Your delivery rates to locations near this vans Home Region
        </div>
        <div className='nearby-locations__container'>
          {nearVan.map((el, i) => (
            <LocationsNearbyItem
              key={i}
              nearVan={el}
              homeLocation={homeLocation}
              existLocations={existLocations}
            />
          ))}
          <Button children='+' variant='contained' onClick={() => setOpenAddNearVans(true)} />
        </div>
      </div>
    </>
  );
};
export default LocationsNearby;
